import script from "./catalogMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./catalogMain.vue?vue&type=script&setup=true&lang=ts"

import "./catalogMain.vue?vue&type=style&index=0&id=98631296&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98631296"]])

export default __exports__